/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccessControllersAll200,
  GetApiV1AccessControllersAll401,
  GetApiV1AccessControllersAll500,
  GetApiV1AccessControllersAllQueryResponse,
} from "../../types/accessController/GetApiV1AccessControllersAll.ts";
import { controllerViewModelSchema } from "../controllerViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccessControllersAll200Schema = z.array(
  z.lazy(() => controllerViewModelSchema),
) as unknown as ToZod<GetApiV1AccessControllersAll200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccessControllersAll401Schema =
  z.any() as unknown as ToZod<GetApiV1AccessControllersAll401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccessControllersAll500Schema =
  z.any() as unknown as ToZod<GetApiV1AccessControllersAll500>;

export const getApiV1AccessControllersAllQueryResponseSchema = z.lazy(
  () => getApiV1AccessControllersAll200Schema,
) as unknown as ToZod<GetApiV1AccessControllersAllQueryResponse>;
